import { AppBar, Toolbar, Typography } from '@mui/material';
import UserMenu from './UserMenu';

const TopBar = () => {
  return (
    <AppBar sx={{ background: 'none', boxShadow: 'none' }} position="static">
      <Toolbar
        sx={{
          justifyContent: 'flex-end',
          borderBottom: '1px solid #f0f0f0',
          background: 'white',
          mb: 3,
        }}
      >
        <Typography variant="h5" flexGrow={1} textAlign="center">
          Digital Anarchy License Manager
        </Typography>
        <UserMenu />
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
